import React from 'react';
import classNames from 'classnames';
import './ActivityTimeline.scss';

export type ActivityView = 'calendar' | 'list';

const OPTIONS: { value: ActivityView; label: string; icon: string }[] = [
  { value: 'calendar', label: 'Calendario', icon: 'pi pi-calendar' },
  { value: 'list', label: 'Lista', icon: 'pi pi-list' },
];

/** A two-option segmented control: native radios, so the keyboard and screen readers treat it as one choice. */
export const ActivityViewToggle = ({
  name,
  value,
  onChange,
}: {
  name: string;
  value: ActivityView;
  onChange: (view: ActivityView) => void;
}) => (
  <fieldset className='activity-view-toggle'>
    <legend>Vista</legend>
    {OPTIONS.map((option) => (
      <label key={option.value} className={classNames({ selected: value === option.value })}>
        <input
          type='radio'
          name={name}
          value={option.value}
          checked={value === option.value}
          onChange={() => onChange(option.value)}
        />
        <i className={option.icon} aria-hidden />
        <span>{option.label}</span>
      </label>
    ))}
  </fieldset>
);
